/* eslint-disable max-len */
import { CommonTranslations } from '../interfaces/common';

const EnglishCommonTranslations: CommonTranslations = {
  home: 'Home',
  login: {
    title: 'Log in',
    labels: {
      email: 'EMAIL',
      password: 'PASSWORD',
      forgotPassword: 'Forgot your password?',
      submit: 'Log in',
      signUp: 'Sign up',
    },
    errors: {
      wrongCredentials: 'Incorrect email or password.',
      noPassword: 'Forgot your password or don’t have one yet? Ask your teacher for a link.',
      teacherContact: 'A teacher? Write to us: info@elkapp.pl',
      generic: 'Could not log in. Please try again in a moment.',
      // Tylko przy innym języku niż polski — po polsku stoi tekst backendu z liczbą minut
      tooManyAttempts: 'Too many login attempts. Please try again in a few minutes.',
    },
  },
  passwordStrength: {
    label: 'Password strength',
    levels: {
      0: 'Too easy',
      1: 'Very easy',
      2: 'Good password',
      3: 'Secure password',
      4: 'Very good password',
    },
    reminder: 'Your password must be level 2 (good password) or higher',
    title: 'Set a password',
    description: 'Make sure the password is strong enough',
  },
  activation: {
    labels: {
      submit: 'Activate account',
      goToLogin: 'Go to login',
    },
    placeholders: {
      password: '●●●●●●●●',
    },
    messages: {
      invalidLinkStudent: 'The activation link is invalid or the account is already active. If you already have a password, log in. If not, ask your teacher for a new link.',
      invalidLinkTeacher: 'The activation link is invalid or the account is already active. If you have a password, log in.',
      genericError: 'Account activation failed. Please try again in a moment.',
    },
  },
  newPassword: {
    title: 'Set a new password',
    submit: 'Save password',
    messages: {
      invalidLink: 'The password link is invalid or has already been used. If your new password is already set, log in. If not, ask your teacher for a new link.',
      success: 'Password changed. You can log in now.',
      error: 'Could not change the password',
      genericError: 'Could not change the password. Please try again in a moment.',
    },
  },
  signUp: {
    title: 'Sign up as a teacher',
    confirm: 'Confirm your email address by clicking the link in the email we have sent you.',
    labels: {
      error: 'Sign-up failed. Please try again in a moment.',
      email: 'Email',
      password: 'Password',
      name: 'First name',
      surname: 'Last name',
      submit: 'Sign up',
      back: 'Back',
    },
    messages: {
      activationError: 'Account activation failed',
      activationSuccess: 'Account activated. You can log in now.',
      error: 'Sign-up failed',
    },
    placeholder: {
      email: 'johnsmith@elk.com',
      password: '●●●●●●●●',
      name: 'John',
      surname: 'Smith',
    },
  },
  requestResetPassword: {
    title: 'Reset',
    subtitle: 'Enter your email address and we will send you instructions',
    labels: {
      submit: 'Reset',
      goBack: 'Back to login',
    },
    placeholders: {
      email: 'Email',
    },
  },
  or: 'or',
  validation: {
    required: 'This field is required',
    name: {
      required: 'First name is required',
    },
    surname: {
      required: 'Last name is required',
    },
    email: {
      invalid: 'Email is invalid',
      required: 'Email is required',
    },
    password: {
      tooShort: 'Password is invalid',
      minLength: 'Password must be at least 10 characters long.',
      tooLong: 'Password is invalid',
      tooWeak: 'Password is too simple',
      required: 'Password is required',
    },
  },
  menu: {
    students: 'Students',
    wordList: 'Word lists',
    catalog: 'Image catalogue',
    memory: 'Memory',
    pairing: 'Matching',
    contact: 'Contact',
    profile: 'My profile',
    logout: 'Log out',
    gamesKiddo: 'E — Easy — game versions for younger children',
    gamesOlder: 'R — Regular — game versions for older children',
  },

  cart: {
    name: 'Cart',
    total: 'Total',
    toCart: 'Go to cart',
  },
  remove: 'REMOVE',
  more: 'See more...',
  for: 'for',
  price: 'Price:',
  pcs: 'pcs',
  quantity: 'Quantity',
  link: 'Link:',
  from: 'From',
  delete: 'Delete',
  company: {
    name: 'ELK',
  },
  footer: {
    copyright: '© {{year}} ELK. All rights reserved.',
    termsAndConditions: 'Terms and conditions',
    privacyPolicy: 'Privacy policy',
    contact: 'Contact',
    api: 'API',
    headers: {
      important: 'Important links',
      services: 'Services',
    },
  },
  contact: {
    title: 'Contact us',
    headquarters: 'Office:',
    email: 'Email: ',
    phone: 'Phone: ',
    send: 'Send',
    successMessage: 'Your message has been sent',
    errorMessage: 'Could not send the message. Please try again later.',
    validation: {
      required: 'This field is required',
      email: 'Invalid email address format',
    },
    placeholders: {
      email: 'Your email',
      message: 'Write your message',
    },
  },
  terms: {
    title: 'Terms and conditions',
  },
  privacyPolicy: {
    title: 'Privacy policy',
  },
  notFound: {
    title: 'Not found',
    subtitle: 'This page does not exist',
    backHome: 'Back to the home page',
  },
  maintenance: {
    title: 'Technical break',
    subtitle: 'Maintenance work is in progress. The app will be available again soon.',
    until: 'Expected return: {{time}}',
    overdue: 'The work is taking longer than planned. We are working on restoring access.',
    refresh: 'Refresh',
    bypassBadge: 'Maintenance mode bypassed',
  },
  buttons: {
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    create: 'Create',
    close: 'Close',
  },
  loading: 'Loading...',
  emptyHere: 'Nothing here yet...',
  language: {
    label: 'Interface language',
  },
};

export default EnglishCommonTranslations;
